import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/style.css'
import Calculator from './components/Calculator';

function App() {
  return (
    <div className="App">
      <Calculator />
    </div>
  );
}

export default App;